import { render, staticRenderFns } from "./frontpage.vue?vue&type=template&id=5f10b50d"
import script from "./frontpage.vue?vue&type=script&lang=ts"
export * from "./frontpage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports